<template>
  <div class="prevent-overlay"></div>
</template>
<script>
function preventTouchScroll(touchElement) {
  var _overlay = document.querySelector(touchElement);
  var _clientY = null;
  _overlay.addEventListener(
    "touchstart",
    function (event) {
      if (event.targetTouches.length === 1) {
        _clientY = event.targetTouches[0].clientY;
      }
    },
    { passive: false }
  );
  _overlay.addEventListener(
    "touchmove",
    function (event) {
      if (event.targetTouches.length === 1) {
        disableRubberBand(event);
      }
    },
    { passive: false }
  );
  function disableRubberBand(event) {
    var clientY = event.targetTouches[0].clientY - _clientY;
    if (_overlay.scrollTop === 0 && clientY > 0) {
      event.preventDefault();
    }
    if (isOverlayTotallyScrolled() && clientY < 0) {
      event.preventDefault();
    }
  }
  function isOverlayTotallyScrolled() {
    return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
  }
}

export default {
  mounted() {
    preventTouchScroll(".prevent-overlay");
    preventTouchScroll("nav");
  },
};
</script>
<style lang="scss" scoped>
.prevent-overlay {
  @media only screen and (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    z-index: 50;
    &.show {
      visibility: visible;
    }
  }
}
</style>